import React from 'react';

const FormContent: React.FC = ({ children }) => (
  <div style={{ padding: '1rem', background: 'white' }}>
    {children}
  </div>
);

export default FormContent;
